// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 20505-商品年龄组查询 根据商品ID查询商品适用的年龄组信息 GET /app/v1/goods/ageGroups/${param0} */
export async function getGoodsAgeGroups(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGoodsAgeGroupsParams,
  options?: { [key: string]: any }
) {
  const { goodsId: param0, ...queryParams } = params;
  return request<API.YmResultVOListSwimAgeGroupListVo>(
    `/app/v1/goods/ageGroups/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20506-周期卡年龄段价格查询 根据商品ID和年龄组ID查询周期卡年龄段价格信息 GET /app/v1/goods/agePrice/${param0} */
export async function getGoodsAgePriceByAgeGroup(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGoodsAgePriceByAgeGroupParams,
  options?: { [key: string]: any }
) {
  const { goodsId: param0, ...queryParams } = params;
  return request<API.YmResultVOListSwimGoodsAgePriceVo>(
    `/app/v1/goods/agePrice/${param0}`,
    {
      method: "GET",
      params: {
        ...queryParams,
      },
      ...(options || {}),
    }
  );
}

/** 20502-商品详情查询 根据商品ID查询商品详情 GET /app/v1/goods/detail/${param0} */
export async function getGoodsDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGoodsDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGoodsDetailVo>(
    `/app/v1/goods/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20504-商品详情内容查询 根据商品ID和详情类型查询商品详情内容 GET /app/v1/goods/detailContent */
export async function getGoodsDetailContent(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGoodsDetailContentParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimGoodsDetailContentVo>(
    "/app/v1/goods/detailContent",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 20509-商品收藏/取消收藏 用户对商品进行收藏或取消收藏操作 POST /app/v1/goods/favorite */
export async function favoriteGoods(
  body: API.GoodsFavoriteActionReqVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOGoodsFavoriteActionRespVo>(
    "/app/v1/goods/favorite",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20511-批量取消收藏 批量取消用户收藏的商品 DELETE /app/v1/goods/favorite/batch */
export async function batchCancelFavorite(
  body: API.BatchCancelFavoriteReqVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOVoid>("/app/v1/goods/favorite/batch", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 20510-用户收藏列表查询 分页查询用户收藏的商品列表 POST /app/v1/goods/favorite/list */
export async function getFavoriteGoodsList(
  body: API.UserFavoriteGoodsQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimGoodsListVo>(
    "/app/v1/goods/favorite/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20508-商品点赞/取消点赞 用户对商品进行点赞或取消点赞操作 POST /app/v1/goods/like */
export async function likeGoods(
  body: API.GoodsLikeActionReqVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOGoodsLikeActionRespVo>("/app/v1/goods/like", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 20501-商品列表查询 分页查询商品列表 POST /app/v1/goods/list */
export async function getGymGoodsList(
  body: API.SwimGoodsAppListQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimGoodsListVo>(
    "/app/v1/goods/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20503-商品价格日历查询 根据商品ID查询商品价格日历信息，可按年龄组过滤 GET /app/v1/goods/priceCalendar */
export async function getGoodsPriceCalendar(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGoodsPriceCalendarParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimGoodsPriceCalendarVo>(
    "/app/v1/goods/priceCalendar",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 20507-推荐商品分页列表查询 分页查询可见的推荐商品列表 POST /app/v1/goods/recommend/pageList */
export async function getRecommendGoodsPageList(
  body: API.SwimRecommendGoodsAppPageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimRecommendGoodsListVo>(
    "/web/v1/recommendGoods/pageList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
